export default "__VITE_ASSET__CjtD6MD1__"